import React from "react";
import bg1 from "../Assets/about/bg1.JPG";

const About = () => {
  return (
    <div className='my-8 md:my-14 lg:my-20 lg:container mx-auto px-4'>
      <h1 className=' text-4xl text-right font-extrabold py-8'>
        <span className='border-b-4 border-b-green-600'>About</span> Us
      </h1>
      <div className='grid grid-cols-1 slg:grid-cols-2 p-4 md:p-8  slg:gap-20 max-w-5xl mx-auto items-center'>
        <img
          src={bg1}
          alt=''
          className='h-[20rem] slg:h-[40rem] object-cover  w-full'
        />

        <div className=' flex flex-col'>
          <div className='border-b-2 spacey-3 flex flex-col py-4 mb-6'>
            <h1 className='text-2xl font-bold my-2'>OPC</h1>
            <h1 className='text-justify'>
              OPC is a non-governmental organisation in Ghana that promotes
              social entrepreneurship in the field of regenerative food and
              farming systems. Our centres connect national and international
              stakeholders and enable them to co- develop applied solutions.
            </h1>
            <h1 className='border-b-2 my-8 w-20 border-green-600'></h1>
          </div>

          <div className='text-sm'>
            <h1 className='text-green-600'>Our Mission</h1>
            <p className='text-justify'>
              Our mission is to make regenerative living mainstream through
              professional education (vocational training and social
              entrepreneurship) Our holistic approach also entails circular
              economy (e.g. natural sanitation, proper waste management and
              renewable energy) and complementary medicine
            </p>
          </div>
          <div className='mt-5'>
            <h1 className='text-green-600'>Vision</h1>
            <p className='text-justify'>
              Our vision is to shape a new generation of leaders in the field of
              regenerative food and farming systems
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
